import React, { HTMLAttributes } from "react";
import classNames from "classnames";

interface PortalTabsProps {
   className?: string;
}

export const PortalTabs: React.FC<PortalTabsProps> = ({ children, className }) => {
   return (<div className={classNames("portal-tabs", className)}>
      {children}
   </div>)
}

export type PortalTabProps = HTMLAttributes<HTMLAnchorElement> & {
   active: boolean
}

export const PortalTab: React.FC<PortalTabProps> = ({ children, active, className, ...rest }) => {
   return (<a href="#" className={classNames("portal-tab", { "portal-tab--active": active }, className)} {...rest}>
      {children}
   </a>)
}